import React, { useEffect, useRef } from 'react';
import Typed from 'typed.js';
import { FaTwitter, FaYoutube, FaInstagram, FaLinkedin, FaGithub } from 'react-icons/fa';
import heroBg from '../images/hero-bg.jpg';

const Hero = () => {
  const typedElement = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (!typedElement.current) return;

    const typed = new Typed(typedElement.current, {
      strings: ['a Site Reliability Engineer', 'a DevOps Enthusiast', 'a Cloud Specialist', 'Azure and AWS Certified', 'Kubernetes Certified'],
      typeSpeed: 50,
      backSpeed: 50,
      backDelay: 2000,
      loop: true,
    });

    return () => {
      typed.destroy();
    };
  }, []);

  return (
    <section
      id="hero"
      className="hero relative min-h-screen text-gray-900 bg-blue-200"
    >
      <div className="hero-portrait" aria-hidden="true">
        <div className="hero-photo" style={{ backgroundImage: `url(${heroBg})` }} />
      </div>
      <div className="hero-content relative" data-aos="zoom-in" data-aos-delay="100">
        <h1 className="hero-title font-bold mb-4 text-gray-700">Mateus Lira</h1>
        <p className="hero-subtitle font-bold text-gray-600">I'm <span ref={typedElement} className="typed text-blue-800"></span></p>
        <div className="hero-social-links social-links mt-4 flex flex-wrap gap-4">
          <a href="https://twitter.com/mateusclira" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-blue-900">
            <FaTwitter className="text-2xl md:text-4xl" />
          </a>
          <a href="https://youtube.com/mateusclira" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-blue-900">
            <FaYoutube className="text-2xl md:text-4xl" />
          </a>
          <a href="https://instagram.com/mateusclira" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-blue-900">
            <FaInstagram className="text-2xl md:text-4xl" />
          </a>
          <a href="https://www.linkedin.com/in/mateusclira" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-blue-900">
            <FaLinkedin className="text-2xl md:text-4xl" />
          </a>
          <a href="https://github.com/mateusclira" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-blue-900">
            <FaGithub className="text-2xl md:text-4xl" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
